import { Inject, Service } from 'vue-di-container';

import AxiosService from './axios';
import LoaderService from './loader';
import { Constants } from '@/utils/constants';

@Service()
export default class RecaptchaService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;
    private isRecaptchaEnabled = false;
    private recaptchaKey = '';
    private initialized = false;
    private useNafathContractVerification = false;
    private enableVerifyForContractVerification = false;

    public async key(): Promise<string> {
        if (!this.initialized) {
            await this.fillConfig();
        }
        return this.recaptchaKey;
    }

    public async isEnabled(): Promise<boolean> {
        if (!this.initialized) {
            await this.fillConfig();
        }
        return this.isRecaptchaEnabled;
    }

    public async useNafathForContractVerification(): Promise<boolean> {
        if (!this.initialized) {
            await this.fillConfig();
        }
        return this.useNafathContractVerification;
    }

    public async isVerifyEnabled(): Promise<boolean> {
        if (!this.initialized) {
            await this.fillConfig();
        }
        return this.enableVerifyForContractVerification;
    }

    /**
     * Validate the token returned from Google ReCaptcha verification service.
     * @param token The token to be validated.
     * @returns True or false.
     */
    public async verify(token: string): Promise<boolean> {
        this.loaderService.ShowLoader();

        try {
            const result = await this.axiosService.axiosInstance.post(`${Constants.RE_CAPTCHA_PATH}/verify`, token, { headers: { 'Content-Type': 'application/json' } });
            return result.data;
            // return true;
            // return await this.axiosService.axiosInstance.post(`${Constants.RE_CAPTCHA_PATH}/verify`, token, { headers: { 'Content-Type': 'application/json' } });

            // const result = await this.axiosService.axiosInstance.post(`${Constants.RE_CAPTCHA_PATH}/verify`, token, { headers: { 'Content-Type': 'application/json' } });

            // if (!result) {
            //   return Promise.reject();
            // }

            // return result.data;
        } catch (e) {
            return false;
        } finally {
            this.loaderService.HideLoader();
        }
    }

    private async fillConfig() {
        const result = await this.axiosService.axiosInstance.get(`config.json?v=${new Date().toISOString()}`);
        this.isRecaptchaEnabled = result.data.Recaptcha.Enabled;
        this.recaptchaKey = result.data.Recaptcha.SiteKey;
        this.initialized = true;
        this.useNafathContractVerification = result.data.Recaptcha.UseNafathForContractVerification;
        this.enableVerifyForContractVerification = result.data.Recaptcha.EnableVerifyForContractVerification;
    }
}
